var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.704 4C7.61688 4 2.66675 8.85053 2.66675 15.2812V28H6.77901C6.77901 28 6.77564 21.0029 6.77564 15.2719C6.77564 9.29023 11.2437 5.02383 15.7278 4.09781C15.9104 4.05888 16.1242 4 15.9113 4H14.704Z",
    fill: "#DD2326"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0259 4.41439C15.4834 4.59612 14.946 4.8206 14.1721 5.30298C10.9424 7.30823 9.49476 10.9953 9.34861 14.5636C9.33914 14.7667 9.3367 14.9685 9.3367 15.1703V15.1694C9.3367 15.1891 9.33325 15.2921 9.33325 15.3258V28H13.5348V15.3258C13.5348 14.5257 13.8976 13.8111 14.467 13.3373L16.1248 15.3258L17.7801 13.3376C18.3494 13.8111 18.7131 14.5257 18.7131 15.3258V28H22.9138V15.3258C22.9138 11.5786 19.8735 8.54092 16.1248 8.54092C15.237 8.54092 14.3899 8.71032 13.6147 9.02029V9.01943C14.475 8.00992 15.7748 7.50961 17.1958 7.47892H17.1992C17.6428 7.4683 18.0985 7.50531 18.5553 7.58621C22.2732 8.19467 25.1057 11.3083 25.1202 15.0634C25.1274 15.2066 25.1299 15.3513 25.1299 15.4986V28H29.3333V15.393C29.3333 9.93284 26.0492 5.55471 20.4517 4.2513C20.2476 4.20497 19.9237 4.13971 19.634 4.10098C19.2201 4.04604 18.7956 4 18.3572 4C17.4477 4 16.7871 4.16094 16.0259 4.41439Z",
    fill: "#0E5AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajidIcon);
export default __webpack_public_path__ + "static/media/majid-icon.22d7b737686cc9e88d840266eee89bfc.svg";
export { ForwardRef as ReactComponent };